import {
    Children,
    useMemo,
    type FC
} from "react";
import {
    ScrollView,
    View
} from "react-native";
import type IAttachmentGroupProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    formatNumber
} from "../../../../helpers/locale";
import {
    AttachmentGroupContext
} from "../../context";
import PresenceList from "../../../presenceList";

const AttachmentGroup: FC<IAttachmentGroupProps> = ({
    layoutBehaviour = "scroll",
    isInitialAnimated = false,
    isInField = false,
    customLocalize,
    customTheme,
    children,
    style,
    title,
    ...props
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const {
        content: contentDynamicStyle
    } = useStyles({
        spaces
    });

    const count = formatNumber({
        value: Children.toArray(children).length,
        locale: activeLocale
    });

    const label = title ? `${title} (${count})` : localize("attachments-count", [
        count
    ]);

    const context = useMemo(() => ({
        isInField
    }), [
        isInField
    ]);

    if(layoutBehaviour === "scroll") {
        return <AttachmentGroupContext.Provider
            value={context}
        >
            <ScrollView
                {...props}
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={[
                    stylesheet.scrollContent,
                    contentDynamicStyle
                ]}
                style={[
                    style,
                    stylesheet.scroll
                ]}
                aria-label={label}
                horizontal={true}
                role="group"
            >
                <PresenceList
                    isInitialAnimated={isInitialAnimated}
                    itemStyle={stylesheet.presenceItem}
                    customTheme={customTheme}
                    axis="x"
                >
                    {children}
                </PresenceList>
            </ScrollView>
        </AttachmentGroupContext.Provider>;
    }

    return <AttachmentGroupContext.Provider
        value={context}
    >
        <View
            {...props}
            style={[
                style,
                stylesheet.wrap,
                contentDynamicStyle
            ]}
            aria-label={label}
            role="group"
        >
            <PresenceList
                isInitialAnimated={isInitialAnimated}
                itemStyle={stylesheet.presenceItem}
                customTheme={customTheme}
            >
                {children}
            </PresenceList>
        </View>
    </AttachmentGroupContext.Provider>;
};
export default AttachmentGroup;
